'use strict';

var App = require('app');
var AppState = require('app_state');
var Misc = require('utils/misc');
var ChartData = require('models/charts');
var ChartsMove = require('utils/charts/charts_move');
var ChartsExport = require('utils/charts/charts_export');
var ChartsZoomButtons = require('utils/charts/charts_zoom_buttons');
var ChartsZoomEnhance = require('utils/charts/charts_zoom_enhance');
var ChartsAutoRefresh = require('utils/charts/charts_auto_refresh');
var ChartsAndroidFix = require('utils/charts/charts_android_fix');
var ChartsAxis = require('utils/charts/charts_axis').ChartsAxis;
var Consts = require('consts');

var ConfigureChartDialogView = require('components/devices/views/common/configure_chart_dialog_view');

var Charts = Marionette.Object.extend({
    id: undefined,
    device: undefined,
    controller: undefined,
    isPredefined: false,
    timePeriods: {
        list: [],
        default: 'today',
        free: 'free',
        getByName: function (name, asJson) {
            var getTimeFromF = function (period, f, isFrom) {
                var getMinuteTime = function (src) {
                    src = src.getTime();
                    var roundF = isFrom ? Math.floor : Math.ceil;
                    return new Date(roundF(src / 60000) * 60000);
                };

                if (f) return getMinuteTime(f.apply(period), isFrom);

                return new getMinuteTime(new Date());
            };

            var period = Misc.findWithKey(this.list, 'name', name);
            var periodObj;

            if (asJson) {
                periodObj = JSON.parse(asJson);
                periodObj.from = new Date(periodObj.from);
                periodObj.till = new Date(periodObj.till);
                periodObj.name = this.free;
                periodObj.updateRange = periodObj.free;
            } else {
                var periodObj = jQuery.extend(true, {}, period);
                periodObj.from = getTimeFromF(period, periodObj.from, true);
                periodObj.till = getTimeFromF(period, periodObj.till, false);
            }

            if (!periodObj.prevFrom) {
                periodObj.prevFrom = function () {
                    return new Date(this.from.getTime() - this.till.getTime() + this.from.getTime());
                };
            }
            if (!periodObj.prevTill) {
                periodObj.prevTill = function () {
                    return new Date(this.prevFrom().getTime() + this.till.getTime() - this.from.getTime());
                };
            }

            if (!periodObj.nextTill) {
                periodObj.nextTill = function () {
                    return new Date(this.till.getTime() + this.till.getTime() - this.from.getTime());
                };
            }

            if (!periodObj.nextFrom) {
                periodObj.nextFrom = function () {
                    return new Date(this.nextTill().getTime() + this.from.getTime() - this.till.getTime());
                };
            }
            return periodObj;
        },

        setDefault: function (name) {
            var p = this.getByName(name);
            if (Misc.findWithKey(this.list, 'name', name) && !p.free) {
                this.default = name;
            }
        },

        getFree: function (periodInfo) {
            var freeItem = this.getByName(Misc.findWithKey(this.list, 'free', true).name);
            freeItem.from = new Date(periodInfo.from * 1000);
            freeItem.till = new Date(periodInfo.till * 1000);
            return freeItem;
        },

        getDefault: function () {
            return this.getByName(this.default);
        },
    },
    plugins: [
        ChartsMove,
        ChartsZoomButtons,
        ChartsZoomEnhance,
        ChartsExport,
        ChartsAutoRefresh,
        ChartsAndroidFix,
        ChartsAxis,
        // ChartsZoomLimit,
    ],

    series: {
        deviceId: undefined,
        deviceCategory: undefined,
        deviceSeries: undefined,
        selectedSeries: undefined,

        colorsToUse: ['rgb(255, 0, 0)', 'rgb(0, 128, 0)', 'rgb(0, 0, 255)', 'rgb(0, 0, 0)'],
        maxSeriesCount: 4,

        getSelectedFromUserConfig: function () {
            var content = AppState.selectedCharts(this.deviceId, this.deviceCategory);
            this.state.content = content;
            return content;
        },

        selected: function (bookmarkCallback) {
            var isConfigChanged = false;
            if (!this.selectedSeries) {
                this.selectedSeries = [];

                // get it from the database
                var dbData = this.getSelectedFromUserConfig() || { advanced_mode: false, lines: [] };
                this.advancedMode = dbData.advanced_mode;

                var dbSelected = dbData.lines;
                if (dbSelected) {
                    for (var i = 0; i < dbSelected.length; i++) {
                        var serie = this.byField(dbSelected[i].device, dbSelected[i].id);
                        if (serie === undefined) {
                            isConfigChanged = true;
                            continue;
                        }
                        var serie = $.extend(false, {}, serie, {
                            index: i,
                            color: dbSelected[i].color,
                            name: dbSelected[i].name,
                            deviceID: '' + (dbSelected[i].device == 0 ? this.deviceId : parseInt(dbSelected[i].device)),
                            lat: dbSelected[i].lat,
                            lon: dbSelected[i].lon,
                            lat2: dbSelected[i].lat2,
                            lon2: dbSelected[i].lon2,
                            secondDeviceID:
                                '' + dbSelected[i].device2 == 0 ? this.deviceId : parseInt(dbSelected[i].device2),
                            secondField: dbSelected[i].field2,
                            op: dbSelected[i].op,
                        });

                        if (serie.secondField) {
                            serie.secondFieldInfo = this.byField(dbSelected[i].device2, dbSelected[i].field2);
                        }

                        if (!serie.deviceID) serie.deviceID = this.deviceId;
                        serie.customLabel = dbSelected[i].label;
                        this.selectedSeries.push(serie);

                        if (dbSelected[i].display.valid) {
                            var d = dbSelected[i].display;

                            serie.displaySettings = {
                                timeshift: d.timeshift,
                                timeWindow: d.timewindow,
                                aggregationFunc: d.aggregation,
                                chartType: d.type,
                                difference: d.difference,
                            };
                        }
                    }
                }

                this.currentDeviceSeries = this.deviceSeries[this.deviceId];

                // nothing available? then take the first one
                if (
                    this.selectedSeries.length == 0 &&
                    this.currentDeviceSeries &&
                    this.currentDeviceSeries.length > 0
                ) {
                    this.selectedSeries.push(
                        $.extend(false, {}, this.currentDeviceSeries[0], { deviceID: '' + this.deviceId })
                    );
                }

                // set labels
                this.setLabels();
            }

            this.updateSeriesFormat();

            if (isConfigChanged && bookmarkCallback) {
                bookmarkCallback();
            }
            return this.selectedSeries;
        },

        updateSeriesFormat: function () {
            _.each(this.selectedSeries, function (a) {
                if (
                    (a.unit || a.format) &&
                    a.secondFieldInfo &&
                    (a.unit != a.secondFieldInfo.unit || a.format != a.secondFieldInfo.format) &&
                    a.op
                ) {
                    a.unit = '';
                    a.format = '';
                }
            });
        },

        getCaption: function () {
            if (this.deviceCount == 1) return this.getDeviceName(this.selectedSeries[0].deviceID);
            if (this.lineTypeCount == 1) return this.selectedSeries[0].name;
            return '';
        },

        getDeviceName: function (devID) {
            var di = AppState.getDeviceInfo(devID);
            if (di) return di.name;
            return '???';
        },

        setLabels: function () {
            var self = this;
            this.deviceCount = _.uniq(_.pluck(this.selectedSeries, 'deviceID')).length;
            this.lineTypeCount = _.uniq(_.pluck(this.selectedSeries, 'field')).length;

            _.each(this.selectedSeries, function (line) {
                if (line.customLabel) {
                    line.label = line.customLabel;
                    return;
                }
                if (self.deviceCount == 1) line.label = line.name;
                else if (self.lineTypeCount == 1) line.label = self.getDeviceName(line.deviceID);
                else line.label = '' + self.getDeviceName(line.deviceID) + ' - ' + line.name;
            });
        },

        byField: function (deviceID, fieldName) {
            var self = this;
            var result;

            AppState.requireCompanyFeatures(function () {
                if (deviceID == 0) {
                    deviceID = self.deviceId;
                }

                if (!self.deviceSeries[deviceID]) {
                    return;
                }

                if (fieldName.startsWith('WD') && AppState.Cache.companyFeatures[Consts.Features.WeatherData]) {
                    // weather data
                    result = _.findWhere(Consts.WeatherData, { field: fieldName });
                    return;
                }

                if (fieldName.startsWith('DEVICE')) {
                    // smart temp data
                    result = _.findWhere(Consts.SmartTempData, { field: fieldName });
                    return;
                }

                for (var i = 0; i < self.deviceSeries[deviceID].length; i++) {
                    if (self.deviceSeries[deviceID][i].field == fieldName) {
                        result = self.deviceSeries[deviceID][i];
                        return;
                    }
                }
            });

            return result;
        },

        setSelected: function (selected) {
            this.selectedSeries = selected;
            if (selected) {
                this.setLabels();
            }
        },

        completeRow: function (row) {
            row.field = row.type + '_' + row.nr;
            row.isBinary = Misc.getValueLikeCoil(row.field);
        },

        reloadAll: function (onFinished, deviceId, resetSelected, allDevices, category) {
            var self = this;
            if (allDevices) {
                this.allDevices = allDevices;
            }

            if (deviceId) {
                this.deviceId = deviceId;
                this.deviceCategory = category;
            }

            if (this.deviceId) {
                var cfgSelected = this.getSelectedFromUserConfig() || { lines: [] };
                // get all involved devices
                var collectDevices = function (index) {
                    return Misc.selectWhere(
                        cfgSelected.lines,
                        function (a) {
                            return parseInt(a[index]);
                        },
                        index
                    );
                };

                var d1 = collectDevices('device');
                var d2 = collectDevices('device2');
                var devices = _.uniq(_.flatten([d1, d2, this.deviceId]));

                // read names of all involved devices
                var requests = _.map(devices, function (id) {
                    return App.request('device:values', id);
                });
                _.each(devices, function (id) {
                    requests.push(App.request('device:smarttemp', id));
                });
                requests.push(App.request('device:names', devices, true));

                // get values for all involved devices
                this.deviceSeries = {};
                $.when.apply($, requests).done(function () {
                    // values first...
                    var values = Array.prototype.slice.apply(arguments, [0, devices.length]);
                    // ... then smart temp info for each device...
                    self.smartTempInfo = _.object(
                        devices,
                        Array.prototype.slice.apply(arguments, [devices.length, arguments.length - 1])
                    );
                    // ...the last one is device:names, no need for that but it must be loaded
                    var cnt = 0;
                    _.each(values, function (ar) {
                        if (!ar) return;
                        var rows = _.filter(ar.toJSON(), function (row) {
                            // values with ascii-format not allowed
                            return !row.format || row.format.indexOf('ascii') < 0;
                        });
                        self.deviceSeries[ar.deviceID] = _.map(rows, function (row) {
                            var newRow = _.clone(row);
                            self.completeRow(newRow);
                            newRow.color = self.colorsToUse[cnt % self.colorsToUse.length];
                            cnt++;
                            return newRow;
                        });
                    });

                    if (resetSelected) self.setSelected(undefined);

                    if (onFinished) {
                        onFinished();
                    }
                });
            }
        },
    },

    init: function (device, controller, category, onInit, defaultPeriod, isPredefined) {
        var self = this;
        this.isPredefined = isPredefined;
        this.device = device;
        this.controller = controller;
        this.category = category;
        this.id = device.id;

        this.timePeriods.list = Misc.getTimePeriodList();
        this.timePeriods.setDefault(defaultPeriod);

        device.set('periods', this.timePeriods.list);
        var chartData = new ChartData({
            deviceId: this.id,
        });
        device.set('chartData', chartData);
        this.state = device.get('chartData').state;
        this.series.state = this.state;

        // read all configured value specs
        this.loadDevices(function () {
            // read all configured value specs
            self.series.reloadAll(onInit, self.id, true, self.allDevices, category);
        });
    },

    getAllDevices: function () {
        return this.allDevices;
    },

    showChartConfigurationDialog: function (view, controller) {
        var self = this;
        // first, update series
        this.series.reloadAll(function () {
            var selectedSeries = self.series.selected();
            self.configureDialogView = new ConfigureChartDialogView({
                deviceID: self.id,
                selectedSeries: selectedSeries,
                allDevices: self.getAllDevices(),
                deviceSeries: self.series.deviceSeries,
                smartTempInfo: self.series.smartTempInfo,
                advancedMode: self.series.advancedMode,
                controller: controller,
                saveData: function (data, onlyThisDevice, advancedMode) {
                    self.saveChartSettings(data, onlyThisDevice, advancedMode);
                },
                isCustomChartSelection: AppState.isCustomChartSelection(self.id),
            });

            App.showModal(self.configureDialogView);
        });
    },

    saveChartSettings: function (newSel, onlyThisDevice, advancedMode) {
        var self = this;
        this.series.advancedMode = advancedMode;

        var getChartSettings = function () {
            var lines = _.map(self.selectedSeries, function (row) {
                return {
                    id: row.field,
                    name: row.name,
                    color: row.color,
                    device: row.deviceID == self.id ? '0' : row.deviceID,
                    lat: row.lat,
                    lon: row.lon,
                    label: row.customLabel,
                    op: row.op,
                    device2: row.secondDeviceID == self.id ? '0' : row.secondDeviceID,
                    lat2: row.lat2,
                    lon2: row.lon2,
                    field2: row.secondField,
                    display: row.displaySettings &&
                        (row.displaySettings.aggregationFunc || row.displaySettings.timeshift) && {
                            timeshift: row.displaySettings.timeshift,
                            timewindow: row.displaySettings.timeWindow,
                            aggregation: row.displaySettings.aggregationFunc,
                            type: row.displaySettings.chartType,
                            difference: row.displaySettings.difference,
                            valid: true,
                        },
                };
            });

            return {
                lines: lines,
                advanced_mode: self.series.advancedMode,
            };
        };
        this.selectedSeries = newSel;
        this.series.updateSeriesFormat();

        var chartSettings = getChartSettings();
        this.state.content = chartSettings;
        if (!this.isPredefined) {
            AppState.saveSelectedSeries(this.state, onlyThisDevice, this.id, this.category);
        } else {
            AppState.saveSelectedSeriesToURL(this.state);
        }

        App.hideModal(this.configureDialogView);
        this.series.setSelected(this.selectedSeries);
        this.chartView.redrawChart(this.selectedSeries);
        if (this.configChanged) {
            this.configChanged();
        }
    },

    updateUrl: function (period) {
        var categoryData = Consts.DeviceCategory[this.category];
        var url = categoryData.url + '/' + this.id + '/analyze';
        if (period && period.name) url = url + '/' + period.name;

        this.state.url = period && period.free ? undefined : url;
        url = '#' + AppState.saveSelectedSeriesToURL(this.state);
        history.pushState({}, document.title, url);
    },

    getPeriodURLData: function (period) {
        if (period && period.free) {
            return {
                from: (60 * period.from.getTime()) / 60000,
                till: (60 * period.till.getTime()) / 60000,
            };
        }
        return {};
    },

    useView: function (view) {
        this.chartView = view;
        // initialize plugins
        for (var i = 0; i < this.plugins.length; i++) {
            var plugin = this.plugins[i];
            var tmp = new plugin(this);
        }
    },

    loadDevices: function (fctDone) {
        var settings = AppState.selectedCharts(this.id, this.category);
        this.state.content = settings;

        // extract all devices
        var devices = _.compact(
            _.flatten([
                this.id,
                _.map((settings || {}).lines, function (line) {
                    return [parseInt(line.device), parseInt(line.device2)];
                }),
            ])
        );

        var req = App.request('device:names', devices, true);
        $.when(req).done(function (devices) {
            fctDone();
        });
    },
});

module.exports = Charts;
